module.exports = __webpack_public_path__ + "static/media/contest-icon.07da3004.svg";